import { computed } from "vue";

import { useViewState } from "@/views/AsCoach/composables/useViewState";

export function useTableConfig() {
  const viewState = useViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Employee to Coach",
          sortable: true,
          value: "employee",
          width: "150px",
        },
        {
          text: "For Responsibility",
          sortable: true,
          value: "responsibility",
        },
        {
          text: "Current Badge",
          sortable: true,
          value: "current_badge",
          width: "100px",
        },
        {
          text: "Inspection Status",
          sortable: true,
          value: "inspection_status",
          width: "150px",
        },
      ],
      columns: [
        {
          field: "",
          component: "EmployeeCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeCardProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "OrgObjectCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getOrgObjectCardProps(item),
          }),
        },
        {
          field: "",
          component: "ProficiencyBadge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getProficiencyBadgeProps(item),
          }),
          events: (item) => ({
            removeBadge: async () => {
              viewState.removeProficiencyBadge(item);
            },
          }),
        },
        {
          field: "",
          component: "InspectionIssueBadge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getInspectionIssueBadgeProps(item),
          }),
          // events: (item) => ({
          //   optionClick: () => {
          //     viewState.handleOptionClick(item);
          //   },
          // }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "current_status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: viewState.state.filters.needsRecalculation
        ? false
        : true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      hideFilterBtn: true,
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
